import ProgramPreview from 'components/views/ProgramPreview';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionCreators as eventsAC } from 'store/events';
import { actionCreators as loginAC, getHasAuthenticationLoaded, getIsAuthenticated } from 'store/login';
import {
	getDsgvo,
	getGender,
	getHealthGoal,
	getIntensity as getUserIntensity,
	getIsAnamnesisDone,
	getIsPreviewUser,
	getIsProfileLoaded,
	getLevel,
	getPoints,
	getShowDsgvoReminder,
	getWeight,
} from 'store/profile';
import {
	actionCreators as programPreviewAC,
	getContainedInformation,
	getDescription,
	getDuration,
	getError,
	getExperts,
	getExternalId,
	getGoal,
	getHasDynamicRecipes,
	getHasDynamicWorkouts,
	getHasProgramChanged,
	getHideExpertLogo,
	getInfo,
	getIntensity,
	getIsInactive,
	getIsLoadingProgram,
	getIsNewProgram,
	getIsProgramPreviewLoaded,
	getIsRecommended,
	getMetaDescription,
	getPreview,
	getPreviewImage,
	getPreviewItems,
	getSeoTitle,
	getSlugs,
	getSlugURL,
	getStartProgramFailed,
	getTitle,
	getTools,
} from 'store/programPreview';
import { getCountActivePrograms, getHasActivePrograms } from 'store/programs';
import { actionCreators as translationAC, getLabelTranslations } from 'store/translation';
import { getCurrentViewID } from 'store/view';
import { WithRouterType } from 'types/withRouter';

const LANGUAGE_ROUTE_PATHS_LABEL: string = 'react.impulsCoach.routes.program.preview.href';

const mapStateToProps = (state, props: any & WithRouterType) => ({
	id: props.match.params.id, // route url
	externalId: getExternalId(state), // ext id
	slug: getSlugURL(state),
	currentViewID: getCurrentViewID(state),
	dsgvo: getDsgvo(state),
	showDsgvoReminder: getShowDsgvoReminder(state),
	isPreviewUser: getIsPreviewUser(state),
	isAuthenticated: getIsAuthenticated(state),
	isAnamnesisDone: getIsAnamnesisDone(state),
	hasActivePrograms: getHasActivePrograms(state),
	hasProgramChanged: getHasProgramChanged(state),
	hasAuthenticationLoaded: getHasAuthenticationLoaded(state),
	countActiveProgram: getCountActivePrograms(state),
	isProgramPreviewLoaded: getIsProgramPreviewLoaded(state),
	isProfileLoaded: getIsProfileLoaded(state),
	isLoadingProgram: getIsLoadingProgram(state),
	isNewProgram: getIsNewProgram(state),
	metaDescription: getMetaDescription(state),
	error: getError(state),
	tools: getTools(state),
	title: getTitle(state),
	points: getPoints(state),
	level: getLevel(state),
	seoTitle: getSeoTitle(state),
	userWeight: getWeight(state),
	description: getDescription(state),
	info: getInfo(state),
	preview: getPreview(state),
	intensity: getIntensity(state),
	hasDynamicWorkouts: getHasDynamicWorkouts(state),
	hasDynamicRecipes: getHasDynamicRecipes(state),
	userIntensity: getUserIntensity(state),
	goal: getGoal(state),
	contains: getContainedInformation(state),
	duration: getDuration(state),
	previewItems: getPreviewItems(state),
	previewImage: getPreviewImage(state, getGender(state)),
	inactive: getIsInactive(state),
	startProgramFailed: getStartProgramFailed(state),
	isRecommended: getIsRecommended(state, getUserIntensity(state), getHealthGoal(state)),
	languageRoutePaths: getLabelTranslations(state, LANGUAGE_ROUTE_PATHS_LABEL), // defs/routes
	slugs: getSlugs(state),
	experts: getExperts(state),
	hideExpertLogo: getHideExpertLogo(state),
	query: props.location.search,
	LANGUAGE_ROUTE_PATHS_LABEL,
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...eventsAC,
			...programPreviewAC,
			...loginAC,
			doResolveTranslation: translationAC.doResolveTranslation,
		},
		dispatch
	);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProgramPreview) as any);
